export const stripHtml = (text: string) => text.replace(/(<([^>]+)>)/gi, '');
export const truncate = (input: string, maxLength: number) =>
  input.length > maxLength - 3 ? `${input.substring(0, maxLength - 3)}...` : input;
